'use client';

import { useCallback, useMemo } from 'react';

type OnRead = (
  data: string | ArrayBuffer | null,
  fileName: string,
  fileType: string
) => void;

type OnError = (handle: string) => void;

const useFileUpload = (
  onError: OnError,
  onRead: OnRead,
  mimeTypes: string[] = [],
  maxSize = 4194304
) => {
  const onDrop = useCallback(
    (files: File[]) => {
      for (const file of files) {
        if (file.size > maxSize) return onError('FILE_SIZE_TOO_LARGE');

        const reader = new window.FileReader();
        reader.addEventListener('error', () => onError('ERROR'));
        reader.readAsDataURL(file);
        reader.onloadend = (readerEvent) =>
          onRead(readerEvent.target!.result, file.name, file.type);
      }
    },
    [onError, onRead, maxSize]
  );

  const accept = useMemo(
    () =>
      mimeTypes.reduce(
        (acc: Record<string, string[]>, cur) => ({ ...acc, [cur]: [] }),
        {}
      ),
    [mimeTypes]
  );

  return { onDrop, accept };
};

export default useFileUpload;
